import { useFormContext } from 'react-hook-form';
import { oneLine } from 'common-tags';

import type { FunctionComponent } from 'react';
import type { TypeTextAreaProps } from './types';

/**
 * TextArea
 */
export const TextArea: FunctionComponent<TypeTextAreaProps> = ({
  className = '',
  rows = 3,
  label,
  name,
  requiredMessage,
  placeholder,
}: TypeTextAreaProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div>
      <label htmlFor={name} className="text-other--label-form uppercase">
        {label}
      </label>

      <textarea
        {...register(name, { required: requiredMessage })}
        name={name ?? 'description'}
        rows={rows}
        {...(placeholder && { placeholder })}
        id={name}
        className={oneLine`
          max-h-96 w-full resize-y border-b bg-transparent font-light outline-none
          ${
            errors[name]
              ? 'border-[#ff0000] text-[#ff0000] placeholder-[#ff0000]'
              : 'border-primary-400 text-primary-400 placeholder-primary-400'
          }
          ${className}
        `}
      />

      <span
        className={oneLine`
          text-other--detail text-[#ff0000]
          ${errors[name] ? 'block' : 'hidden'}
        `}
      >
        {requiredMessage}
      </span>
    </div>
  );
};

TextArea.displayName = 'TextArea';
